var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route"},[_c('Spinner'),_c('FilterRoutes'),_c('SubHeaderBlock'),_c('div',{staticClass:"container"},[_c('TableBlock',{staticClass:"route__table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }